var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grade-management"},[_c('topBar'),_c('gradeList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }